<button
  appButton
  variant="ghost"
  size="sm"
  type="button"
  class="audio-transcription__toggle"
  [attr.aria-expanded]="expanded()"
  (click)="onToggle()"
>
  {{ expanded() ? 'Ocultar transcrição' : 'Transcrever' }}
</button>

@if (expanded()) {
  <div class="audio-transcription__panel">
    @switch (state()) {
      @case ('loading') {
        <app-ui-skeleton-row [height]="10" width="100%" aria-busy="true" />
        <app-ui-skeleton-row [height]="10" width="72%" aria-busy="true" />
      }
      @case ('success') {
        <p class="audio-transcription__text">{{ text() }}</p>
        <p class="audio-transcription__hint">Transcrição automática — pode conter erros.</p>
      }
      @case ('empty') {
        <p class="audio-transcription__hint">Nenhuma fala detectada neste áudio.</p>
      }
      @case ('error') {
        <p class="audio-transcription__error">Não foi possível transcrever agora.</p>
        <button appButton variant="secondary" size="sm" type="button" (click)="onRetry()">
          Tentar de novo
        </button>
      }
      @case ('insufficient_credit') {
        <p class="audio-transcription__error">Sem crédito disponível para transcrever este áudio no momento.</p>
        <div class="audio-transcription__actions">
          <a appButton variant="secondary" size="sm" routerLink="/configuracoes/cobranca">Ver crédito</a>
          <button appButton variant="ghost" size="sm" type="button" (click)="onRetry()">Tentar de novo</button>
        </div>
      }
    }
  </div>
}
